import { useState, useEffect } from "react";

import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import { FormInput, FormDropDownList } from "../FormComponents";
import { getTargetWorktype } from "../../../data/worktypeData";
import { getWorktypeGroupDropdown } from "../../../data/workTypeGroupData";
import { dropDown } from "../../../data/interfaces";

import SkeletonForm from "../../Skeletons/SkeletonForm";

const EditWorkTypeForm = (props: any) => {
  const [visible, setVisible] = useState(false);
  const [worktypeGroupData, setWorktypeGroupData] = useState<dropDown[]>([]);

  const [formState, setFormState] = useState({
    description: "",
    worktypeGroup: {
      value: 0,
      text: "",
    },
  });
  const [loading, setLoading] = useState(true);
  const worktypeId = props.onWorktypeId;
  const readOnly = props.canEdit === false;

  const toggleDeleteDialog = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    const fetchPlaceholderData = async () => {
      const worktype = await getTargetWorktype(worktypeId);
      setFormState({
        description: worktype.description,
        worktypeGroup: {
          value: worktype.worktypegroupId,
          text: worktype.group,
        },
      });
    };

    const fetchWorktypeGroupData = async () => {
      const worktypeData = await getWorktypeGroupDropdown();
      setWorktypeGroupData(worktypeData);
    };
    setLoading(false);

    fetchWorktypeGroupData();
    fetchPlaceholderData();
  }, [worktypeId]);

  const handleSubmit = () => {
    // alert(JSON.stringify(formState, null, 2));
    props.onEditSubmit(formState, worktypeId);
  };

  const handleDelete = () => {
    props.onWorktypeDelete(worktypeId);
    setVisible(!visible);
  };

  return loading ? (
    <SkeletonForm />
  ) : (
    <div className="form__wrapper">
      <div style={{ display: "flex", width: "100%" }}>
        <Form
          onSubmit={handleSubmit}
          render={(formRenderProps) => (
            <FormElement
              style={{ padding: "1rem", width: "100%", marginBottom: "5rem" }}
            >
              <fieldset className={"k-form-fieldset"} disabled={readOnly}>
                <div className="form__subtitle">{readOnly ? "Work type details:" : "Edit work type details:"}</div>
                {readOnly && <p className="k-form-hint">You have view-only access to worktypes.</p>}

                <Field
                  data={worktypeGroupData}
                  name={"worktypeId"}
                  component={FormDropDownList}
                  disabled={readOnly}
                  label={"Choose the type of work:"}
                  defaultText={formState.worktypeGroup.text}
                  defaultValue={formState.worktypeGroup.value}
                  onChange={(e) => {
                    setFormState({
                      ...formState,
                      worktypeGroup: {
                        ...e.value,
                        value: parseInt(e.value.value, 10),
                      },
                    });
                  }}
                  hasButton={false}
                />

                <Field
                  name={"description"}
                  component={FormInput}
                  disabled={readOnly}
                  label={"Description: "}
                  placeholder={formState.description}
                />

                {!readOnly && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    padding: "1rem 2rem 1rem 2rem",
                    position: "absolute",
                  }}
                >
                  <button
                    onClick={() => {
                      handleSubmit();
                      formRenderProps.onFormReset();
                    }}
                    className="form__edit__button edit"
                  >
                    Save changes to Worktype
                  </button>
                  <button
                    onClick={toggleDeleteDialog}
                    className="form__edit__button reject"
                  >
                    Mark Worktype as Deleted
                  </button>
                </div>
                )}
              </fieldset>
            </FormElement>
          )}
        />
      </div>
      {visible && (
        <Dialog title={"Please confirm"} onClose={toggleDeleteDialog}>
          <p
            style={{
              margin: "25px",
              textAlign: "center",
            }}
          >
            Are you sure you want to delete {formState.description}?
          </p>
          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={toggleDeleteDialog}
            >
              No
            </button>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={handleDelete}
            >
              Yes
            </button>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};

export default EditWorkTypeForm;
